<template>
  <div class="seller-publisher-report">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true" style="fill: #fff">
        <use xlink:href="#icon-shangpin"></use>
      </svg>
    </breadcrumbs>
    <noticeTool/>
    <a-spin :spinning="spinning">
      <div class="content-main" ref="mainRef">
        <div class="content-head">
          <div class="content-head-left">
            <artmisads-segmented-tabs v-model="activeTab" :items="programConfig" />
            <p>
              <span v-if="tagNumParams.lastUpdateAt">
                Last Update at: {{moment(tagNumParams.lastUpdateAt).format('YYYY-MM-DD hh:mm')}}
              </span>
            </p>
          </div>
          <a-dropdown :getPopupContainer="() => mainRef">
            <template #overlay>
              <artmisads-dropdown-menu @click="handleExportClick">
                <a-menu-item key="all">Export All Data</a-menu-item>
                <a-menu-item key="filter">Export with Filters</a-menu-item>
              </artmisads-dropdown-menu>
            </template>
            <artmisads-button-special>
              <svg class="icon daochu" aria-hidden="true">
                <use xlink:href="#icon-daochu"></use>
              </svg>
              <span class="btn-text">Export</span>
              <svg class="icon artmisads-select-down-icon" aria-hidden="true">
                <use xlink:href="#icon-jiantou-xia-cu"></use>
              </svg>
            </artmisads-button-special>
          </a-dropdown>
        </div>
        <filterBar
          :params="params"
          :getList="getList"
          :setParams="setParams"
          :dateParams="[params.startReportDateTimestamp, params.endReportDateTimestamp]"
          platform="operator"
          :hide-operator-user-filters="activeTab === '2'"
        />
        <div class="tags">
          <filterTag
            :naList="activeTab === '0' ? ['clicks'] : []"
            :setParams="setParams"
            :tagNumParams="tagNumParams"
            :marketplace="params.marketplace"
            :defaultMetricName="defaultMetricName"
            :noNeedList="noNeedList"
          />
        </div>
        <div class="content">
          <p>
            {{RESPORTS_TYPE_MAP[params.metricName].name}}
            <span v-if="showTop10">(Top 10)</span>
          </p>
          <div class="chart">
            <chart
              :showDate="false"
              :dataList="dataList"
              :width=chartWidth
              showYName="publisherName"
              showXName="metricValue"
              :isPercent="params.metricName === 'acosAmount'"
              :lineColor="chartParams.lineColor"
              :lineBgOffsetTop="chartParams.lineBgOffsetTop"
              :lineBgOffsetZero="chartParams.lineBgOffsetZero"
              chartType="bar"
              :selectDaysNum="selectDaysNum"
              :showCurrent="false"
              :startTimestamp="params.startReportDateTimestamp"
              :endTimestamp="params.endReportDateTimestamp"
              :onClickBarChart="onClickBarChart"
              :metricName="params.metricName"
            />
          </div>
          <div class="table">
            <tableContent
              :dataList="tableList"
              :marketplace="params.marketplace"
              :tableTotal="tableTotal"
              :params="tableParams"
              :activeTab="activeTab"
              :setParams="setTableParams"
              :onClickTableChart="onClickTableChart"
              :tagNumParams="tagNumParams"
            />
          </div>
        </div>
      </div>
    </a-spin>
    <lineChartModal
      v-if="showlineChartModal"
      title="Publisher Report"
      :activeTab="activeTab"
      :itemInfo="itemInfo"
      :isPercent="params.metricName === 'acosAmount'"
      :onCancleModal="onCancleModal"
      pageType="operatorPublisher"
      :marketplace="params.marketplace"
       :defaultMetricName="params.metricName"
      :noNeedList="noNeedList"
    />
  </div>
</template>
<script setup>
  import { computed, onMounted, ref, watch, onBeforeMount, nextTick } from 'vue';
  import moment from 'moment';
  import { publisherAdminApi } from '~/server/index'
  import { RESPORTS_TYPE_MAP } from '~/contants/reports';
  import breadcrumbs from '../../breadcrumbs.vue';
  import filterBar from '~/components/reports/filterBar.vue';
  import filterTag from '~/components/reports/filterTag.vue';
  import lineChartModal from '~/components/reports/lineChartModal.vue';
  import noticeTool from '~/components/reports/noticeTool.vue';
  import chart from '~/components/reports/chart.vue';
  import tableContent from './tableContent.vue';
  import { useUserInfoStore } from "@/storeData";
  import { CURRENCY_MAPPER } from "@/contants/common";
  import { useSystemStore } from '@/storeData/system'
  const systemStore = useSystemStore()
  
  const breadcrumbsData = {
    title: 'Publisher Reports',
    color:'#4682FA',
    // hasTitleIcon:true,
    links: [
      {
        name: 'Home',
        path: '/operator/dashboard'
      },
      {
        name: 'Reports',
        path: '/operator/reports/performance'
      },
      {
        name: 'Publisher',
        path: '/operator/reports/publisher'
      }
    ]
  };
  const user = useUserInfoStore();
  const showTop10 = ref(false);
  const showlineChartModal = ref(false);
  const chartWidth = ref(1092);
  const spinning = ref(false);
  const dataList = ref([]);
  const mainRef = ref();
  const countryCode = user?.userInfo?.countryCode || 'US';
  const params = ref({
    marketplace: CURRENCY_MAPPER[countryCode].host,
    startReportDateTimestamp:moment().subtract(7, 'day').startOf('day').valueOf(),
    endReportDateTimestamp: moment().startOf('day').valueOf(),
    brandId: null,
    productId: null,
    metricName: 'detailPageViews',
    asin: null,
  })

  const needOpenPublisherId = ref('');
  const itemInfo = ref();
  const tableList = ref([]);
  const tableTotal = ref(0);
  const tableParams = ref({
    page: 1,
    size: 200,
    sortDirection: '',
    sortField: ''
  })

  const tagNumParams = ref({
    totalClicks: null,
    totalDetailPageViews: null,
    totalAddToCart: null,
    totalConversions: null,
    totalOrders: null,
    totalSalesAmount: null,
    totalDiscountedSalesAmount: null,
    totalBonusAmount: null,
    totalCommissionAndFeeAmount: null,
    lastUpdateAt: null
  });

  const activeTab = ref('0')
  const programConfig = computed(() => {
    const src = systemStore.programConfig || []
    const tabs = src.map((item) => ({ ...item }))
    // 仅 Publisher 页单独追加 Creator Connections
    if (!tabs.some((item) => item.key === '2')) {
      tabs.push({
        key: '2',
        label: 'Creator Connections',
        disabled: false,
      })
    }
    return tabs
  })
  const defaultMetricName = ref('detailPageViews')
  const noNeedList = ref([
    'orders',
    'clicks',
    'conversionsRate',
    'commissionAmount',
    'bonusAmount',
    'quantity',
    'finalCommissionAndFeeAmount',
    'finalCommissionAmount',
  ])
  const isResetting = ref(false)

  const selectDaysNum = computed(() => {
    const { endReportDateTimestamp, startReportDateTimestamp } = params.value;
    const intervalDays = moment(endReportDateTimestamp).diff(moment(startReportDateTimestamp), 'days');
    return intervalDays;
  });

  const chartParams = computed(() => {
    let lineColor, lineBgOffsetTop, lineBgOffsetZero, chartParamsData, itemData;
    itemData =  RESPORTS_TYPE_MAP[params.value.metricName];
    lineColor = itemData.lineColor;
    lineBgOffsetTop = itemData.lineBgOffsetTop;
    lineBgOffsetZero = itemData.lineBgOffsetZero;
    chartParamsData = { lineColor, lineBgOffsetTop, lineBgOffsetZero }
    return chartParamsData;
  })

  const getChartWidth = () => {
    const $chart = document.querySelector('.chart');
    const widthNum = $chart.clientWidth - 20;
    chartWidth.value = widthNum;
  }

  const setTableParams = obj => {
    const newObj = {...tableParams.value, ...obj};
    tableParams.value = newObj;
  }

  const setParams = obj => {
    const newObj = {...params.value, ...obj};
    setTableParams({page:1})
    params.value = newObj;
  }

  watch(params, async (newValue, oldValue) => {
    if (isResetting.value) {
      return
    }

    if (newValue.metricName !== oldValue.metricName) {
      switch (activeTab.value) {
        case '0':
          spinning.value = true
          await getList()
          spinning.value = false
          break
        case '1':
          spinning.value = true
          await getListAssociate()
          spinning.value = false
          break
        case '2':
          spinning.value = true
          await getListCc()
          spinning.value = false
          break
      }
    } else {
      switch (activeTab.value) {
        case '0':
          getAllData()
          break
        case '1':
          getAllDataAssociate()
          break
        case '2':
          getAllDataCc()
          break
      }
    }
  }, { deep: true, flush: 'post' })

  watch(tableParams, async (newValue, oldValue) => {
    if(isResetting.value) return
    const hasChanged = Object.keys(newValue).some(key => newValue[key] !== oldValue[key])
    if (hasChanged) {
      switch(activeTab.value){
        case '0':
          spinning.value = true
          await getTableList()
          spinning.value = false
          break
        case '1':
          spinning.value = true
          await getTableListAssociate()
          spinning.value = false
          break
        case '2':
          spinning.value = true
          await getTableListCc()
          spinning.value = false
          break
      }
    }
  }, { deep: true, flush: 'post' })

  watch(activeTab, async () => {
    await reserParams()
    await reserTableParams()
    switch (activeTab.value) {
      case '0':
        noNeedList.value = [
          'orders',
          'clicks',
          'conversionsRate',
          'commissionAmount',
          'bonusAmount',
          'quantity',
          'finalCommissionAndFeeAmount',
          'finalCommissionAmount',
        ]
        defaultMetricName.value = 'detailPageViews'
        getAllData()
        break
      case '1':
          noNeedList.value = [
       'clicks',
        'detailPageViews',
        'addToCart',
        'conversions',
        'orders',
        'conversionsRate',
        'acosAmount',
        'discountedSalesAmount',
        'bonusAmount',
        'commissionAmount',
        'finalCommissionAmount',
      ]
        defaultMetricName.value = 'quantity'
        getAllDataAssociate()
        break
      case '2':
        noNeedList.value = [
          'detailPageViews',
          'addToCart',
          'conversions',
          'conversionsRate',
          'quantity',
          'acosAmount',
          'discountedSalesAmount',
          'commissionAndFeeAmount',
          'commissionAmount',
          'finalCommissionAndFeeAmount',
          'finalCommissionAmount',
        ]
        defaultMetricName.value = 'clicks'
        getAllDataCc()
        break
    }
  })

  const reserParams = async() => {
    isResetting.value = true
    nextTick(() => {
      params.value = {
        marketplace: CURRENCY_MAPPER[countryCode].host,
        startReportDateTimestamp: moment().subtract(7, 'day').startOf('day').valueOf(),
        endReportDateTimestamp: moment().startOf('day').valueOf(),
        brandId: null,
        productId: null,
        metricName:
          activeTab.value === '0'
            ? 'detailPageViews'
            : activeTab.value === '1'
              ? 'quantity'
              : 'clicks',
        asin: null,
      }
      nextTick(() => {
        isResetting.value = false
      })
    })
  }

  const reserTableParams = async() => {
    isResetting.value = true
    nextTick(() => {
      tableParams.value = {
        page: 1,
        size: 200,
        sortDirection: '',
        sortField: ''
      }
      nextTick(() => {
        isResetting.value = false
      })
    })
  }

  const onClickBarChart = clickData => {
    // 从新的参数格式中获取数据
    const publisherName = clickData.name || clickData; // 兼容旧格式
    let item = clickData.itemData;
    
    // 如果没有通过itemData获取到数据，使用原来的查找方式
    if (!item) {
      item = dataList.value.find(i => i.publisherName === publisherName);
    }
    itemInfo.value = item;
    itemInfo.value.startReportDateTimestamp = params.value.startReportDateTimestamp
    itemInfo.value.endReportDateTimestamp = params.value.endReportDateTimestamp
    showlineChartModal.value = true;
  }

  const onClickTableChart = item => {
    itemInfo.value = item;
    itemInfo.value.startReportDateTimestamp = params.value.startReportDateTimestamp
    itemInfo.value.endReportDateTimestamp = params.value.endReportDateTimestamp
    showlineChartModal.value = true;
  }

  const onCancleModal = () => {
    showlineChartModal.value = false;
    itemInfo.value = undefined;
  } 

  const getList = async () => {
   
 
    let newparams = {...params.value};

    if (newparams.metricName === 'acosAmount') {
      newparams.metricName = 'acos'
    }
    
    const res = await publisherAdminApi.commissionReportsPublisherMetric(newparams);
   
     if (res) {

       let dataArr=[]
      if (res.length > 10) {
      dataArr  = res.splice(0, 10);
        showTop10.value = true;
      }else{
         dataArr =res
      }


      dataList.value = newparams.metricName === 'acos' ? dataArr.map(item => {
        return {
          ...item,
          metricValue: (item.metricValue * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
        }
      }) : dataArr ;
     
    }
  }

  const getTableList = async () => {
    
    let newparams = {...params.value, ...tableParams.value};
    const res = await publisherAdminApi.commissionReportsPublisher(newparams);
   
    if (res) {
      tableList.value = res.data;
      tableTotal.value = res.total;
      if (needOpenPublisherId.value) {
        const needOpenPublisherItem =  res.data.find(item => item.publisherId === Number(needOpenPublisherId.value));
        if (needOpenPublisherItem) {
          onClickTableChart(needOpenPublisherItem);
        }
        needOpenPublisherId.value = null;
      }
    }
    
  }

  const getSellerCommissionReportsAgg = async () => {
   
    const res = await publisherAdminApi.commissionReportsAggPerformance(params.value);
    if (res) {
      tagNumParams.value = res;
    }
    
  }

  // Associate API functions
  const getListAssociate = async () => {
    
    let newparams = { ...params.value }
    const res = await publisherAdminApi.associateCommissionReportsPublisherMetric(newparams)
    let { success, data } = res
    if (success) {
      if (data.length > 10) {
        data = data.splice(0, 10)
        showTop10.value = true
      }
      dataList.value = newparams.metricName === 'acos' ? data.map(item => {
        return {
          ...item,
          metricValue: (item.metricValue * 100).toFixed(2).replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
        }
      }) : data
    }
    
  }

  const getTableListAssociate = async () => {
    
    let newparams = { ...params.value, ...tableParams.value }
    const res = await publisherAdminApi.commissionReportsPublisherAssociate(newparams)
    const { success, data } = res
    if (success) {
      tableList.value = data.data
      tableTotal.value = data.total
      if (needOpenPublisherId.value) {
        const needOpenPublisherItem = data.data.find(item => item.publisherId === Number(needOpenPublisherId.value))
        if (needOpenPublisherItem) {
          onClickTableChart(needOpenPublisherItem)
        }
        needOpenPublisherId.value = null
      }
    }
    
  }

  const getSellerCommissionReportsAggAssociate = async () => {
    
    const res = await publisherAdminApi.associateCommissionReportsAggPerformance(params.value)
    if (res) {
      tagNumParams.value = res
    }
    
  }

  const handleExportClick = async ({ key }) => {
    let exportParams = {
      endReportDateTimestamp: moment().startOf('day').valueOf(),
      marketplace: params.value.marketplace,
      startReportDateTimestamp: moment().subtract(365, 'day').startOf('day').valueOf(),
    }, newExportParams = {}
    if (key === 'filter') {
      exportParams = { ...params.value }
    }
    for (let item in exportParams) {
      if (exportParams[item]) {
        newExportParams[item] = exportParams[item]
      }
    }
    const finalParams = {
      qs: newExportParams,
      fileName: `Publisher-Reports-${moment().format('YYYY-MM-DD')}.csv`,
       platform: 'operatorV2',
    }
    switch (activeTab.value) {
      case '0':
        finalParams.fileName = `Publisher-Reports-Attribution-${moment().format('YYYY-MM-DD')}.csv`
        publisherAdminApi.commissionReportsPublisherExport(finalParams)
        break
      case '1':
        finalParams.platform='operator'
        finalParams.fileName = `Publisher-Reports-Associate-${moment().format('YYYY-MM-DD')}.csv`
        publisherAdminApi.associateCommissionReportsPublisherExport(finalParams)
        break
      case '2':
        finalParams.platform='operator'
        finalParams.fileName = `Publisher-Reports-CreatorConnections-${moment().format('YYYY-MM-DD')}.csv`
        publisherAdminApi.commissionReportsPublisherExportCc(finalParams)
        break
    }
  }

  const checkFromDashboard = () => {
    const artemisAds_dashboard_click_top_publisher = localStorage.getItem('artemisAds_dashboard_click_top_publisher');
    if (artemisAds_dashboard_click_top_publisher) {
      needOpenPublisherId.value = artemisAds_dashboard_click_top_publisher;
      localStorage.setItem('artemisAds_dashboard_click_top_publisher', '');
    }
  }

  onBeforeMount(() => {
    checkFromDashboard();
  })
  const getAllData = async () => {
    spinning.value = true
    try {
      const results = await Promise.allSettled([
        getSellerCommissionReportsAgg(),
        getList(),
        getTableList()
      ])
      
      // 检查是否有失败的请求
      const failedResults = results.filter(result => result.status === 'rejected');
      if (failedResults.length > 0) {
        console.error('部分请求执行失败:', failedResults);
      }
    } catch (error) {
      console.error('请求执行失败:', error);
    } finally {
      spinning.value = false
    }
  }
  const getAllDataAssociate = async () => {
    spinning.value = true
    try {
      const results = await Promise.allSettled([
        getSellerCommissionReportsAggAssociate(),
        getListAssociate(),
        getTableListAssociate()
      ])
      
      // 检查是否有失败的请求
      const failedResults = results.filter(result => result.status === 'rejected');
      if (failedResults.length > 0) {
        console.error('部分请求执行失败:', failedResults);
      }
    } catch (error) {
      console.error('请求执行失败:', error);
    } finally {
      spinning.value = false
    }
  }

  const getListCc = async () => {
    const newparams = { ...params.value }
    const res = await publisherAdminApi.commissionReportsPublisherMetricCc(newparams)
    if (res) {
      showTop10.value = res.length > 10
      let dataArr = res
      if (dataArr.length > 10) {
        dataArr = dataArr.splice(0, 10)
      }
      dataList.value = dataArr
    }
  }

  const getTableListCc = async () => {
    const newparams = { ...params.value, ...tableParams.value }
    const res = await publisherAdminApi.commissionReportsPublisherCc(newparams)
    if (res) {
      tableList.value = res.data
      tableTotal.value = res.total
    }
  }

  const getSellerCommissionReportsAggCc = async () => {
    const res = await publisherAdminApi.commissionReportsAggCc(params.value)
    if (res) {
      tagNumParams.value = {
        ...res,
        totalOrders: res.totalOrders ?? res.totalConversions ?? 0,
        totalClicks: res.totalClicks ?? 0,
      }
    }
  }

  const getAllDataCc = async () => {
    spinning.value = true
    try {
      const results = await Promise.allSettled([
        getSellerCommissionReportsAggCc(),
        getListCc(),
        getTableListCc(),
      ])
      const failedResults = results.filter((result) => result.status === 'rejected')
      if (failedResults.length > 0) {
        console.error('部分请求执行失败:', failedResults)
      }
    } catch (error) {
      console.error('请求执行失败:', error)
    } finally {
      spinning.value = false
    }
  }

  onMounted(async() => {
    if(needOpenPublisherId.value){
      params.value.metricName ='salesAmount'
      defaultMetricName.value = 'salesAmount'
    }
    document.querySelector('.seller-publisher-report').scrollIntoView()
    getChartWidth();
    getAllData()
    window.addEventListener('resize', function() {
      getChartWidth();
    });
  })

</script>
<style lang="less" scoped>
  .seller-publisher-report {
    padding:0 16px;
  .content-main {
    border-radius: 12px;
    overflow: hidden;
    border-radius: 12px;
    background-color: var(--color-white);
    box-shadow: var(--section-box-shadow-6);
    .tags {
      padding: 20px 12px;
    }
    .content-head {
      display: flex;
      justify-content: space-between;
      height: 64px;
      padding-left: 16px;
      padding-right: 16px;
      .content-head-left {
        display: flex;
        align-items: center;
        gap: 14px;
      }
      > p {
        font-size: 14px;
        color: var(--dark-2);
        line-height: 19px;
        align-self: center;
      }
      > button {
        align-self: center;
        cursor: pointer;
        display: flex;
        .jiantou {
          width: 16px;
          height: 16px;
          fill: var(--dark-3);
          margin-left: 8px;
        }
        .daochu {
          width: 20px;
          height: 20px;
          margin-right: 8px;
          fill: var(--dark-1);
        }
        > svg {
          align-self: center;
        }
        > span {
          align-self: center;
        }
        .btn-text {
          align-self: center;
          font-weight: 500;
          line-height: 20px;
          margin-right: 8px;
        }
      }
    }
  }
  .content {
    padding: 16px;
    
    .table {
      margin-top: 40px;
    }
    .chart {
      padding: 0 10px;
    }
    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-bottom: 30px;
      > span {
        color: var(--red-text);
        font-size: 16px;
        margin-left: 10px;
        line-height: 28px;
      }
    }
  }
}
</style>
